import { getEnvVar, getEnvBoolean } from '@egr/xbox/utils/ReactScriptHelper';

export const PCON_LOGIN_CLIENT_ID: string = getEnvVar('PCON_LOGIN_CLIENT_ID', '');
export const PCON_LOGIN_PUBLIC_TOKEN_CLIENT_ID: string = getEnvVar('PCON_LOGIN_PUBLIC_TOKEN_CLIENT_ID', PCON_LOGIN_CLIENT_ID);
export const PCON_LOGIN_PUBLIC_TOKEN_ENABLED: boolean = getEnvVar('PCON_LOGIN_PUBLIC_TOKEN_ENABLED', 'false') === 'true';
export const PCON_LOGIN_REQUEST_RESELLER: boolean = getEnvBoolean('PCON_LOGIN_REQUEST_RESELLER');
export const PCON_LOGIN_SESSION_REQUIRED: boolean = getEnvBoolean('PCON_LOGIN_SESSION_REQUIRED', false);